<template>
  <div class="app">
    <div class="topBox">
      <div class="logo">
        <img :src="bannerImg" class="banners" />
        <!-- <div class="port fl"></div> -->
        <div class="logo_name">
          <img class="head_img" :src="logoUrl" />
          <div class="user_message">
            <div class="user_name">{{ names }}</div>
            <div
              style="
                margin-top: 8px;
                display: flex;
                justify-content: space-between;
                width: 84px;
                font-size: 10px;
              "
            >
              <span>普通会员</span>
              <!-- <img class="vipLogo" src="/static/image/level.png" /> -->
            </div>
          </div>
          <div class="card_numbers">NO:{{ tateData.VIPNO }}</div>
        </div>
        <div class="head_content">
          <div class="con_item paddingline">
            <p class="con_text_tit">
              {{ tateData.Integral ? tateData.Integral : 0 }}分
            </p>
            <p class="con_text">积分</p>
          </div>
          <div class="con_item paddingline">
            <p class="con_text_tit">
              {{ tateData.Money ? toFix(Number(tateData.Money)) : 0 }}元
            </p>
            <p class="con_text">余额</p>
          </div>
          <router-link to="/myCoupon" class="con_item">
            <p class="con_text_tit">{{ cardLength }}张</p>
            <p class="con_text">优惠券</p>
          </router-link>
        </div>
      </div>

      <!-- <div class="itemposter" v-if="posterList.length > 1">
        <mt-swipe :auto="3000">
          <mt-swipe-item
            v-for="(item, idx) of posterList"
            :key="idx"
            @tap="posterDetail(item)"
          >

            <img
              v-if="item.banners[0] && item.banners[0].thumbUrl"
              :src="item.banners[0].thumbUrl"
              style="width: 100%; height: 100%; text-align: center"
              @click="posterDetail(item)"
            />
            <div v-else style="width: 100%; height: 100%">暂无图片</div>

          </mt-swipe-item>
        </mt-swipe>
      </div> -->
      <!-- <div class="itemposter" v-if="posterList.length == 1">
        <img
          v-if="posterList[0].banners[0] && posterList[0].banners[0].thumbUrl"
          :src="posterList[0].banners[0].thumbUrl"
          style="width: 100%; height: 100%; text-align: center"
          @click="posterDetail(posterList[0])"
        />
      </div> -->
      <div class="mains">
        <!-- <div class="mask" v-if="hasRegister" @click="toRegister"></div> -->
        <!-- <div class="main_tit">
          常用功能
        </div> -->
        <div class="main_con">
          <router-link
            to="/PaymentCode"
            class="main_item"
            v-if="bindStatus === true"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/zf.png" />
              <p class="main_text">支付</p>
            </div>
          </router-link>
          <router-link
            to="/Recharge"
            class="main_item"
            v-if="bindStatus === true"
          >
            <div style="text-align: center; width: 100%" class="borderline">
              <img class="main_headimg" src="/static/image/hycz.png" />
              <p class="main_text">充值</p>
            </div>
          </router-link>
          <router-link
            to="/consumptionRecord"
            class="main_item"
            v-if="bindStatus === true"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/xfjl.png" />
              <p class="main_text">消费记录</p>
            </div>
          </router-link>
          <router-link
            to="/Detail"
            class="main_item"
            v-if="bindStatus === true"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/czjll.png" />
              <p class="main_text">充值记录</p>
            </div>
          </router-link>
          <router-link
            to="/myCoupon"
            class="main_item"
            v-if="bindStatus === true"
          >
            <div style="text-align: center; width: 100%" class="borderline">
              <img class="main_headimg cardlogo" src="/static/image/kq.png" />
              <p class="main_text card_text">卡券</p>
            </div>
          </router-link>
          <router-link
            to="/Integral"
            class="main_item"
            v-if="bindStatus == true ? true : false"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/jfjl.png" />
              <p class="main_text">积分记录</p>
            </div>
          </router-link>
          <router-link
            to="/IntegralExchange"
            class="main_item"
            v-if="bindStatus == true ? true : false"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/jfdh.png" />
              <p class="main_text">积分兑换</p>
            </div>
          </router-link>
          <router-link
            to="/BindingMember"
            class="main_item"
            v-if="bindStatus !== true"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/bangkas.png" />
              <p class="main_text">绑卡</p>
            </div>
          </router-link>
          <router-link
            to="/Registers"
            class="main_item"
            v-if="
              bindStatus !== true && companyID !== '61ca6ef251aeb2275ba7b084'
            "
          >
            <div
              style="text-align: center; width: 100%; border-right: none"
              class="borderline"
            >
              <img class="main_headimg" src="/static/image/zhuces.png" />
              <p class="main_text">注册</p>
            </div>
          </router-link>

          <!-- 商城 -->
          <!-- <router-link
            to="/Mall"
            class="main_item"
            v-if="bindStatus === true && shopContent.show && isShop === true"
          >
            <div style="text-align: center; width: 100%" class="borderline">
              <img class="main_headimg" src="/static/image/sc.png" />
              <p class="main_text">商城</p>
            </div>
          </router-link> -->
          <!-- <router-link
            to="/MyOrder"
            class="main_item"
            v-if="bindStatus === true && shopContent.show && isShop === true"
          >
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/czjl.png" />
              <p class="main_text">订单</p>
            </div>
          </router-link> -->
          <router-link
            to="/activeCenter"
            class="main_item"
            v-if="!!(bindStatus === true && bannerAct.length)"
          >
            <div style="text-align: center; width: 100%" class="borderline">
              <img
                class="main_headimg actlogo"
                src="/static/image/activecenter.png"
              />
              <p class="main_text card_text" style="margin-top: 13px">
                活动中心
              </p>
            </div>
          </router-link>
          <div
            class="main_item"
            @click="clickRelieve()"
            v-show="bindStatus === true"
          >
            <div style="text-align: center; width: 100%" class="borderline">
              <img class="main_headimg" src="/static/image/jcbd.png" />
              <p class="main_text">解除绑定</p>
            </div>
          </div>
          <!-- <router-link to="/weixinBind" class="main_item">
            <div style="text-align: center; width: 100%">
              <img class="main_headimg" src="/static/image/czjl.png" />
              <p class="main_text">微信注册</p>
            </div>
          </router-link> -->
        </div>
      </div>
    </div>
    <div class="Choice" v-if="binding">
      <div class="cho1">是否解除绑定</div>
      <div class="cho2">
        <div
          style="border-right: 1px solid #e0e0e0"
          @click="clickBinding(false)"
        >
          取消
        </div>
        <div @click="clickBinding(true)">确定</div>
      </div>
    </div>
    <!-- 更新弹窗 -->
    <div class="ChoiceVersion" v-if="reload">
      <div class="choHeight">
        当前版本为:{{ version }}, 线上最新版本为{{ newVersion }},
        低版本可能会导致部分功能失效, 请刷新页面以更新到最新版本或点击下方按钮。
      </div>
      <div class="cho3 chociceChange">
        <div @click="clickReload()">现在更新</div>
      </div>
    </div>
    <div class="Choice2" v-if="versionModal > 10">
      <div class="cho1">
        <input placeholder="管理员密码" v-model="adminPass" />
      </div>
      <div class="cho1">
        <input placeholder="最新版本号" v-model="adminVersion" />
      </div>
      <div class="cho3">
        <div @click="changeVersionModal()">确定</div>
      </div>
    </div>
    <!-- 优惠券弹窗 -->
    <div class="coupon" v-if="false">
      <div class="coupon_main">优惠券</div>
      <router-link to="/Actives/?type=tanceng" class="routerLink">
        <div class="coupon_sure" @click="getCoupon(true)">确定领取</div>
      </router-link>
      <div class="coupon_false" @click="getCoupon(false)">x</div>
    </div>
    <!-- 活动 -->
    <!-- <div class="routerLink" v-if="bannerAct.length && activeShow">
      <div class="active_false" @click="activeShow = false">
        x
      </div> -->
    <!-- <div class="banners"></div> -->
    <!-- <swiper :btn="true">
        <swiper-slider v-for="item of bannerAct" :key="item.id">
          <router-link
            :to="{
              path: 'Actives',
              query: {
                type: 'banner',
                url: item.material && item.material.banner,
                id: item.id,
                shopIDs: item.shops,
                sharePicUrl: item.sharePicUrl && item.sharePicUrl,
                shareTitle: item.shareTitle && item.shareTitle,
                shareText: item.shareText && item.shareText,
                code: code,
                appcode: appcode,
                shareAble: item.shareAble
              }
            }"
          >
            <img :src="item.material.banner" class="swiperitem" />
          </router-link>
        </swiper-slider>
      </swiper> -->
    <!-- </div> -->
    <Promptbox v-if="prom" :message="Tips"></Promptbox>

    <span class="banbenhao" @click="clickVersionModal()">{{ version }}</span>
    <div
      style="display: none;this is padding data:填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充"
    >
      this is padding
      data:填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填
    </div>
    <loading v-if="load"></loading>
    <div class="mask" v-if="load || reload"></div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'mint-ui'
import _ from 'lodash'
// import "swiper/dist/js/swiper";
// import "swiper/dist/css/swiper.css";
export default {
  name: 'BindingMenmberCard',
  components: {
    Swipe,
    SwipeItem,
  },
  data() {
    return {
      appcode: '',
      code: '',
      tateData: {},
      binding: false,
      load: false,
      Tips: '',
      prom: false,
      logoImg: '',
      logoUrl: localStorage.getItem('logoUrl'),
      huodongImg: '',
      imgFalse: true,
      couponShow: true,
      bannerAct: [],
      names: localStorage.getItem('names'),
      hasRegister: false,
      bindStatus: false,
      cardLength: 0,
      h5: true,
      apptype: '',
      bannerImg: '/static/image/bannerDefault.png',
      shopName: '微信会员卡',
      // shopContent: {},
      openIdList: [],
      activeShow: true,
      posterList: [],
      companyID: localStorage.getItem('companyID'),
      version: 'v1.0.27',
      reload: false,
      versionModal: 0,
      adminPass: '',
      adminVersion: '',
    }
  },
  mounted() {
    // 门店列表
    // this.getShopList()
    // 强制更新H5    pre判断  版本号判断
    // const versions = localStorage.getItem('version')
    const pre = process.env.NODE_ENV

    const companyID = localStorage.getItem('companyID') //&& pre === 'pre'
    if (
      companyID === '60aa4076d35c97da155b85f9' ||
      companyID === '65dc54008120edcbe745ef1f' ||
      companyID === '62148f573c0a4c0fa305a0ff'
    ) {
      // 处理链接小程序--------------start---------------

      if (companyID === '62148f573c0a4c0fa305a0ff') {
        // 旺角测试聚合
        this.RequestLocalNew(
          'POST',
          '/mp/getUnionidByOpenid',
          { openid: localStorage.getItem('code') },
          (res) => {
            if (res.data.code === '20000') {
              if (
                // this.bindStatus &&
                this.$route.query.goto &&
                this.$route.query.goto !== 'undefined'
              ) {
                window.location.href = `/#/${this.$route.query.goto}`
              }
            }
          },
          (err) => console.log(err)
        )
      } else {
        this.RequestLocal(
          'POST',
          '/mp/getUnionidByOpenid',
          { openid: localStorage.getItem('code') },
          (res) => {
            if (res.data.code === '20000') {
              if (
                // this.bindStatus &&
                this.$route.query.goto &&
                this.$route.query.goto !== 'undefined'
              ) {
                window.location.href = `/#/${this.$route.query.goto}`
              }
            }
          },
          (err) => console.log(err)
        )
      }

      // 处理链接小程序--------------end---------------
      this.RequestVIP('h5/config/version/latest', (res) => {
        if (res.data.code === '20000') {
          const versions = res.data.data ? res.data.data.version : 'v0.0.0'

          if (versions) {
            this.newVersion = versions
            // 判断是否需要更新   版本不同并且 线上版本比本地版本高
            const localVersion = this.version.split('.')
            const originVersion = versions.split('.')
            localVersion[0] = localVersion[0].split('v')[1]
            originVersion[0] = originVersion[0].split('v')[1]
            let changeVer = true
            _.map(localVersion, (item, idx) => {
              if (Number(item) > Number(originVersion[idx])) {
                changeVer = false
              }
            })
            // console.log(
            //   localVersion,
            //   originVersion,
            //   'originVersionoriginVersion'
            // )
            if (versions !== this.version && changeVer) {
              // 强制更新
              this.reload = true
              return
            }
          }
        }
      })
    }

    this.couponShow =
      sessionStorage.getItem('showCoupon') == 'false' ? false : true

    this.appcode = localStorage.getItem('appcode')
    this.code = localStorage.getItem('code')
    this.logoImg = 'https://ssl.cnuri.cn/source_img/' + this.appcode + '.jpg'
    this.huodongImg =
      'https://ssl.cnuri.cn/source_img/' + this.appcode + '_banner1.jpg'
    const codes = localStorage.getItem('code')
    // 优惠券数量

    // banner
    this.RequestVIP(
      `h5/vip/company/info`,
      (res) => {
        console.log(res, 'pppppppppppppp')
        if (!!res.data.data.poster && !!res.data.data.poster[0].banners) {
          this.posterList = res.data.data.poster
        }
        if (res.data.code === '20000' && !!res.data.data.image) {
          this.bannerImg = res.data.data.image
          this.shopName = res.data.data.name
        }
      },
      (err) => console.log(err)
    )
    // userinfo
    this.load = true
    this.RequestVIP(
      `h5/vip/info?openID=${this.code}&CompanyID=${companyID}`,
      (res) => {
        this.load = false
        console.log(res, 'resultressssssss')
        if (res.data.code === '50000') {
          this.tateData = []
          this.bindStatus = false
          return
        }
        this.logoUrl = res.data.data.headimgurl
        this.names = res.data.data.nickname
        localStorage.setItem('names', res.data.data.nickname)
        localStorage.setItem('logoUrl', res.data.data.headimgurl)
        // console.log(res.data.data.table1, "rererererere");
        if (!!res.data.data.table1 && !!res.data.data.table1.length) {
          localStorage.setItem('VIPNO', res.data.data.table1[0].VIPNO)
          localStorage.setItem('Integral', res.data.data.table1[0].Integral)
          localStorage.setItem('Money', res.data.data.table1[0].Money)
          localStorage.setItem('payclient', res.data.data.table1[0].payclient)
          localStorage.setItem('signClient', res.data.data.table1[0].signClient)
          this.tateData = res.data.data.table1[0]
          if (!!codes) {
            this.RequestVIP(
              `h5/coupon/all?openID=${codes}&cardNo=${
                res.data.data.table1[0].VIPNO
              }&comID=${localStorage.getItem('companyID')}`,
              (res) => {
                console.log(res, 'resresresresllll')
                let data = res.data.data.result
                this.cardLength =
                  data.length &&
                  data.filter((item) => {
                    return (
                      (item.status == 1 && item.isUsed == false) ||
                      item.status == 3
                    )
                  }).length
              },
              (err) => console.log(err)
            )
          }
          this.bindStatus =
            res.data.data.table1[0] && !!res.data.data.table1[0].VIPNO
              ? true
              : false

          // 判断是否跳转商城
          const toShop = localStorage.getItem('toShop')
          if (toShop == 'true' && !!res.data.data.table1[0].VIPNO) {
            localStorage.setItem('toShop', false)
            window.location.href = '/#/Mall'
          }
          // 绑定会员卡券官方-----------
          // const cardHref = localStorage.getItem('cardHref')
        } else {
          this.tateData = []
          this.bindStatus = false
          localStorage.removeItem('VIPNO')
        }
        if (
          !res.data.data.table1 ||
          !res.data.data.table1[0] ||
          !res.data.data.table1[0].TEL
        ) {
          this.hasRegister = true
        }
      },
      (err) => {
        this.tateData = []
        this.load = false
      }
    )
    this.RequestVIP(
      'h5/campaign/all',
      (r) => {
        if (r.data.code == '20000') {
          const { data } = r.data
          this.bannerAct =
            data.length &&
            data.filter((item) => item.material && item.material.banner !== '')
        }
      },
      (err) => console.log(err)
    )
  },
  updated() {},
  computed: {
    // isShop() {
    //   if (
    //     this.openIdList.length == 0 ||
    //     (this.openIdList.length > 0 && this.openIdList.indexOf(this.code) > -1)
    //   ) {
    //     return true
    //   }
    //   return false
    // },
  },
  methods: {
    is3rdPayment() {},
    // getShopList() {
    //   this.RequestMall('GET', 'h5/mall/shop/all', {}, (r) => {
    //     console.log(r, 'rererelllll')
    //     localStorage.setItem('shopID', r.data.data.result[0].id)
    //     localStorage.setItem('shopList', JSON.stringify(r.data.data.result))
    //     this.shopContent = r.data.data.result[0]
    //     this.openIdList = r.data.data.result[0].whiteList
    //   })
    // },
    // posterDetail(item) {
    //   console.log(item)
    //   this.$router.push({
    //     path: '/PosterDetail',
    //     query: { data: JSON.stringify(item) },
    //   })
    // },
    toFix(val) {
      return val.toFixed(2)
    },
    toRegister() {
      this.$router.push({
        path: '/Registers',
      })
    },
    getCoupon() {
      sessionStorage.setItem('showCoupon', false)
      this.couponShow = false
    },
    clickRelieve() {
      this.binding = true
    },
    clickReload() {
      const timestamp = new Date().getTime()
      localStorage.setItem('version', this.version)
      const companyID = localStorage.getItem('companyID')
      window.location.href = `https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=${companyID}&pre=true&canary=true&timestamp=${timestamp}`
    },
    clickVersionModal() {
      console.log(this.versionModal, 'verisisisisis')
      this.versionModal += 1
    },
    changeVersionModal() {
      console.log(this.adminPass, this.adminVersion, 'adminnnnnnnn')
      if (this.adminPass && this.adminVersion) {
        this.RequestVIP3(
          'h5/config/version/latest',
          {
            version: this.adminVersion,
            description: '更新',
            admin: this.adminPass,
          },
          () => {
            this.versionModal = 0
            this.Tips = 17
            this.prom = true
            setTimeout(() => {
              this.prom = false
            }, 2000)
          }
        )
      } else {
        this.versionModal = 0
      }
    },
    // jiebang
    clickBinding(val) {
      const codes = localStorage.getItem('code')
      if (val) {
        this.binding = false

        this.RequestVIP2(
          '/h5/vip/unbind',
          { openID: codes.replace(/(^\s*)|(\s*$)/g, '') },
          (r) => {
            // console.log(r, "unbinding...........");

            this.Tips = 6
            this.prom = true
            this.tateData = {}
            this.bindStatus = false
            localStorage.removeItem('VIPNO')
            let timer = setTimeout(() => {
              this.prom = false
              clearTimeout(timer)
            }, 1000)
          }
        )
      } else {
        this.binding = val
      }
    },
    imgError() {
      this.imgFalse = false
    },
  },
}
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
  overflow: scroll;
  background: #f5f5f5;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.topBox {
  background: #f5f5f5;
  height: 58%;
}

.bottomBox {
  height: 38%;
  margin-top: 2%;
  background: #fff;
}

.logo {
  width: 100%;
  position: relative;
  height: 130px;
  /* box-shadow: 0px 0px 4px 0px #bdbdbd; */

  background: #ffffff;
  /* position: relative; */
}

.logo_ba {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.port {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #fff;
  margin: 15px;
}

.logo_name {
  width: calc(100% - 34px);
  height: 30%;
  margin-left: 17px;
  padding-top: 15px;
  z-index: 99;
  display: flex;
  color: #fff;
  font-size: 10px;
  position: relative;
  justify-content: space-between;
}

.head_img {
  width: 42px;
  height: 42px;
  border-radius: 50px;
}

.logo_name > .user_message {
  position: absolute;
  top: 18px;
  left: 55px;
}

/* .vipLogo {
  width: auto;
  height: 10px;
  margin-top: -1px;
} */
.logo_name > div {
  font-size: 8px;
  position: absolute;
  right: 0px;
  top: 15px;
  /* margin-bottom: 16px; */
}

.user_name {
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
}

.logo_name > span {
  font-size: 8px;
}

.head_content {
  width: calc(100% - 30px);
  margin: 33px 15px 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.head_content .con_item {
  height: 20px;
  /* line-height: 30px; */
  width: 33%;
  color: #fff;
  text-align: center;
  text-decoration: none;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.con_img {
  width: 30px;
  height: 30px;
  /* border-radius: 50px; */
}

.con_text_tit {
  font-size: 11px;
  font-weight: 500;
  /* margin-top: 5px; */
}

.con_text {
  font-size: 8px;
  margin-top: 5px;
}

.mains {
  width: 100%;
  height: 276px;
  border-radius: 5px;
  background: #fff;
  /* margin-top: 8px; */
  z-index: 99;
  /* padding: 11px; */
  box-sizing: border-box;
  overflow: scroll;
}

.mask {
  width: 100vw;
  height: 100vh;
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.2;
}

.main_con {
  width: 100%;
  overflow: scroll;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 11px;
  box-sizing: border-box;
}

.main_item {
  width: 33.33%;
  text-align: center;
  text-decoration: none;
  height: 69px;
  border-bottom: solid 1px #eeeeee;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  /* margin-top: 14px; */
}

.main_headimg {
  width: auto;
  height: 21px;
}

.main_text {
  font-size: 8px;
  color: #757575;
  text-decoration: none;
  margin-top: 8px;
}

.TEL {
  position: absolute;
  bottom: 8px;
  right: 15px;
  color: #fff;
  font-size: 9px;
}

.cententBox {
  height: 20%;
  border-bottom: 0.5px solid #e0e0e0;
  margin-top: 3%;
  color: #212121;
}

.balance {
  width: 32%;
  height: 100%;
}

.balance > div {
  text-align: center;
}

.balance > div:nth-child(1) {
  padding-top: 8%;
  font-size: 12px;
  font-weight: bold;
}

.balance > div:nth-child(2) {
  padding-top: 6%;
  font-size: 10px;
  color: #757575;
}

.xian {
  border-left: 0.5px solid #e0e0e0;
  height: 50%;
  margin-top: 5%;
}

.Choice {
  width: 120px;
  height: 60px;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  margin-left: -60px;
  z-index: 999;
  box-shadow: 0px 0px 5px 0px #757575;
  border-radius: 4px;
}
.ChoiceVersion {
  width: 120px;
  height: 120px;
  background: #fff;
  position: fixed;
  top: 40%;
  left: 48%;
  margin-top: -30px;
  margin-left: -60px;
  padding: 10px;
  z-index: 99999;
  box-shadow: 0px 0px 5px 0px #757575;
  border-radius: 4px;
  word-spacing: 3px;
  font-size: 10px;
}
.choHeight {
  height: 80px;
  color: #424242;
}
.Choice2 {
  width: 120px;
  height: 100px;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  margin-left: -60px;
  z-index: 999;
  box-shadow: 0px 0px 5px 0px #757575;
  border-radius: 4px;
}
.Choice2 > .cho1 > input {
  height: 16px;
  width: 70%;
  font-size: 12px;
}
.cho1 {
  height: 35px;
  font-size: 11px;
  color: #212121;
  text-align: center;
  line-height: 35px;
}

.cho2 {
  height: 25px;
}

.cho2 > div {
  width: calc(50% - 0.5px);
  border-top: 0.5px solid #e0e0e0;
  float: left;
  height: 25px;
  text-align: center;
  line-height: 25px;
  font-size: 10px;
}
.cho3 > div {
  width: 100%;
  border-top: 0.5px solid #e0e0e0;
  float: left;
  height: 25px;
  text-align: center;
  line-height: 25px;
  font-size: 10px;
}
.chociceChange {
  margin-top: 20px;
  padding-top: 3px;
  font-weight: 500;
}
.coupon {
  position: fixed;
  top: 80px;
  left: 25px;
  width: 200px;
  height: 214px;
  background: #ffffff;
  border: 1px solid #707070;
  opacity: 1;
  border-radius: 26px;
  z-index: 9999999999999;
  text-align: center;
}

.coupon_sure {
  width: 146px;
  height: 29px;
  text-align: center;
  font-weight: 500;
  line-height: 29px;
  font-size: 14px;
  color: #ffffff;
  background: linear-gradient(307deg, #ff9c60 0%, #ff5a61 100%);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 15px;
  position: absolute;
  bottom: -10px;
  left: 27px;
}

.coupon_false {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  opacity: 1;
  font-size: 14px;
  font-weight: 500;
  background: #ffffff;
  position: absolute;
  bottom: -60px;
  left: 85px;
  text-align: center;
}

.active_false {
  width: 30px;
  height: 30px;
  line-height: 28px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  opacity: 1;
  font-size: 18px;
  font-weight: 500;
  background: #ffffff;
  position: absolute;
  top: 300px;
  left: calc(50% - 15px);
  text-align: center;
}

.swiperitem {
  width: 234px;
  height: 117px;
  border-radius: 6px;
  margin: 15px 0 0 8px;
}

/* .posterBG {
  background: #ffffff;
} */
.itemposter {
  width: 100%;
  height: 67px;
  border-radius: 6px;
  margin: 8px 0 0;
}

.routerLink {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 99999999999;
  text-decoration: none;
  background: rgba(0, 0, 0, 0.39);
}

.returnUni {
  width: 70px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: white;
  border-radius: 50px;
  font-size: 9px;
  /* margin-left: -5px; */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.banners {
  width: calc(100% - 16px);
  height: 114px;
  position: absolute;
  top: 8px;
  left: 8px;
  border-radius: 5px;
  box-shadow: 0 2px 2px #e0e0e0;
  /* z-index: -1; */
}

.paddingline {
  /* padding-right: 25px; */
  border-right: solid 1px #ffffff;
  box-sizing: border-box;
  /* text-align: center; */
}

.borderline {
  border-left: solid 1px #eeeeee;
  border-right: solid 1px #eeeeee;
}

.cardlogo {
  width: 24px;
  height: 17px;
}

.actlogo {
  height: 17px;
  /* margin-top: 5px; */
}

.card_text {
  margin-top: 12px;
}

.banbenhao {
  position: fixed;
  bottom: 0;
  left: 47%;
}
</style>



// WEBPACK FOOTER //
// src/BindingMenmberCard/index.vue